import React from "react";

import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import Button from "@mui/material/Button";
import { ArrowUpward, ArrowDownward, Delete } from "@mui/icons-material";

export default function MatrixColumnsEditor({ columns, onUpdate, readOnly }) {
  // Local buffer to avoid triggering saves on every keystroke
  const [localCols, setLocalCols] = React.useState(columns || []);

  React.useEffect(() => {
    setLocalCols(columns || []);
  }, [columns]);

  const move = (i, dir) => {
    const j = i + dir;
    if (j < 0 || j >= localCols.length) return;
    const next = [...localCols];
    [next[i], next[j]] = [next[j], next[i]];
    setLocalCols(next);
    // Discrete action -> persist immediately
    onUpdate(next);
  };

  const updateLocal = (i, field, value) => {
    const next = [...localCols];
    next[i] = { ...next[i], [field]: value };
    setLocalCols(next);
  };

  const commit = () => {
    // Commit buffered edits on blur
    onUpdate(localCols);
  };

  const add = () => {
    const baseLen = localCols.length;
    const next = [...localCols, {
      id: 0,
      code: ["D","C","B","A","E","F"][baseLen] || `C${baseLen+1}`,
      label: "Level",
      // Min/Max removed from UI. Keep fixed values to satisfy backend schema.
      min: 1, max: 1, order: baseLen + 1
    }];
    setLocalCols(next);
    // Discrete action -> persist immediately
    onUpdate(next);
  };

  const remove = (i) => {
    const next = [...localCols];
    next.splice(i,1);
    setLocalCols(next);
    // Discrete action -> persist immediately
    onUpdate(next);
  };

  return (
    <div className="card p-3 mb-3">
      <div className="d-flex justify-content-between mb-2">
        <h6 className="m-0">Matriz – Columnas</h6>
        {!readOnly && <Button variant="outlined" onClick={add}>Agregar columna</Button>}
      </div>

      {(localCols || []).map((c, i) => (
        <div className="row align-items-end mb-2" key={c.id || c.code || i}>
          <div className="col-md-2">
            <TextField
              label="Código"
              variant="outlined"
              value={c.code || ""}
              onChange={e => updateLocal(i, "code", e.target.value)}
              onBlur={commit}
              fullWidth
              disabled={readOnly}
            />
          </div>
          <div className="col-md-3">
            <TextField
              label="Etiqueta"
              variant="outlined"
              value={c.label || ""}
              onChange={e => updateLocal(i, "label", e.target.value)}
              onBlur={commit}
              fullWidth
              disabled={readOnly}
            />
          </div>
          <div className="col-md-3 d-flex">
            {!readOnly && (
              <>
                <IconButton onClick={() => move(i,-1)}><ArrowUpward/></IconButton>
                <IconButton onClick={() => move(i, 1)}><ArrowDownward/></IconButton>
                <IconButton onClick={() => remove(i)}><Delete/></IconButton>
              </>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}
